import React from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useTurnoverModel } from "../turnoverModel";
import useNavModel from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { formatNum } from "@/utils/utils";
import { Button } from "antd";
export const DataBox = () => {
    const { loadData, descTotal, selectedRowKeys, rowsDescTotal, turnoverExcel } = useTurnoverModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const onEdit = () => {
        turnoverExcel()
    }
    const title = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onEdit}
    >{Locale["export"]}</Button>

    const desc: IDescription[] = [
        {
            // label: "应收金额",
            label: Locale["Receivable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivableAmount : formatNum(rowsDescTotal.receivableAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已收金额",
            label: Locale["Received Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.receivedAmount : formatNum(rowsDescTotal.receivedAmount),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={title} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}